import { useState } from "react";
import ArabicConsentModal from "./ArabicConsentModal";

const ConsentAdultArabicUAE = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const programObjectiveHTML = `
  <div dir="rtl" style="text-align: right; font-family: 'Arial Arabic', sans-serif;">
    <div class="program-section">
    <h2>1. الهدف من البرنامج</h2>
    <p>برنامج دعم ماي رأي هو برنامج "البرنامج" يدعم المرضى الذين وصف لهم عقار دوريكست؟! @عقارنا" حيث يساعدهم في اتباع النظام العالجي الذي يحدد الطيب المعلم فضلاً عن توجيهم بملرض ردعمهم تعليمياً حتى يتكبؤوا مع طريقهم، ويعنف هذا البرنامج أيضاً إلى التسجيع على فهم أفضل للأمراض التي يمكن علاجها بعقارنا وإدارتها من خلال التعليلات والأبحاث المتقدمة التي يتم إجراؤها استناداً على مجموعات البيانات المجمعة ومجهولة المصدر الناتجة عن البيانات التي يتم جمعها كجزء من البرنامج.</p>
    
    <p>وهذا البرنامج اقرتحته ومرحله مجموعة سانوفي لينتين (وضع مركز دبي السلم المتعدد) "مجموعة سانوفي" وتتولى شركة بياني للرعاية الصحية المنزلية "مقدم الخدمة" تنفيذه وإدارته بالنهاية عن مجموعة سانوفي.</p>
    
    <p>وليس الغرض من هذا البرنامج الترويج لعقارنا أو أي منتج آخر من منتجات مجموعة سانوفي كما لا يدعم أي مزارع تتفلغ بكفاءة العقار وألو سلامته، فهو لا يعنف إلى الترويج بشكل مباشر للعقار أو أي من منتجات مجموعة سانوفي، كما أن المعلومات التي يتم جمعها في إطار تنفيذ البرنامج لا يمكن استخدامها لأغراض تجارية وألو تسويقية.</p>
    </div>

    <div class="program-section">
    <h2>2. خدمات الدعم</h2>
    <p>للبرنامج أغراض تأمينية حصرية حيث تم إعداده لتزويدك معلومات تخصصية ودعم ظروفك من خلال مجموعة من الخدمات يُشار إليها فيما يلي "خدمات الدعم" على النحو المبين أدناه:</p>
    
    <ul>
        <li>ستحصل على الدعم حتى تشكل من إدارة موضاف وعالجك بشكل أفضل من خلال المعرضين الذين سيتواصلون معك وألو يلقانون بك حسب احتياجاتك، وسوف تحصل على رقم الخط الساخن ومواد تطبيقية، ويمكن أن تحصل على خدمات الدعم هذه من خلال قنوات مختلفة من بينها (على سبيل المثال لا الحصر) الاتصال بك من قبل موظفين ضربين "المامين" في الامارات العربية المتحدة.</li>
    </ul>
    
    <p>ولا يكون هذا البرنامج بديالً لزيارات الطبيب، فلا يمكن لنظم الخدمة والمامنين التابعين له تقديم أي مشورة أو معلومات بشأن علاقتك بطبيبك، حيث يتقصر دورهم على تقديم خدمات تطبيقية، وهذه الخدمات لا يمكن أن تخل محل المشورة الطبية في أي وقت من الأوقات.</p>
    </div>

    <div class="program-section">
    <h2>3. أنت ومشاركتك في البرنامج</h2>
    <h3>أ. التسجيل في البرنامج والخروج منه</h3>
    <p>التسجيل في البرنامج اختياري ومجاني ويمكنك الخروج من البرنامج في أي وقت ودون إداء أي أسباب، وينجز طلبك للإلغاء من خلال إرسال إشعار كتابي، موقع وموزع منك، إلى شركة بياني للرعاية الصحية المنزلية عبر عنوان البريد التالي: pspsafety@baytihhc.com أو من خلال بيانات الاتصال الموضحة أدناه: 800 – BAYTI (22984)</p>
    
    <p>ويحق لمجموعة سانوفي بموجب إشعار مسبق إنهاء البرنامج في أي وقت وأي سبب، ويمكن طبيعيًا بإنقاف اشتراكك في البرنامج في أي وقت (على سبيل المثال لأسباب طبية) وان قررت التوقف عن استخدام المقار فسوف ينتهي اشتراكك في البرنامج تفقيلاً حيث أنه يُشرط للاشتراك في البرنامج أن تتناول هذا المقار لكن يجب أن تكلّد من أن قرار الخروج من البرنامج وأو توافق عن تناول المقار لن يؤثر بأي شكل من الأشكال على خضوعك للإشراف أو الرقابة الطبية من قبل طبيبك.</p>
    
    <h3>ب. بيانات الشخصية</h3>
    <p>لالستفادة من خدمات الدعم المقدمة من خلال البرنامج يجب عليك تسجيل وتقديم بيانات الاتصال الخاصة بك، كما يجب عليك كجزء من البرنامج تقديم بياناتك الشخصية (الموضحة أدناه) أثناء تواصلك مع مقدم الخدمة والمامنين التابعين له.</p>
    
    <ul>
        <li><strong style="font-weight: 700;">"البيانات الشخصية":</strong> يُفسد بها كافة البيانات الشخصية إلى نفسها كجزء من عملية التسجيل في البرنامج وأثناء واصلك مع المامنين أو أي بيانات شخصية قد تقدمها لأغراض تتفلغ بخدمات الدعم.</li>
        <li><strong style="font-weight: 700;">الغرض:</strong> الغرض من جمع بياناتك الشخصية هو الموافقة وتسهيل عملية التواصل طوال فترة الاشتراك في البرنامج. يرجى ملاحظة أن بياناتك الشخصية لن تُعالج بطريقة تتعارض مع الغرض الذي جُمعت من أجله.</li>
    </ul>
    
    <p><strong style="font-weight: 700;">فئات/محتوى البيانات:</strong> لتحقيق الأغراض المتكررة أعلاه، سيتم جمع ومعالجة البيانات الشخصية التالية وفقاً لما هو موضح في هذا النموذج:</p>
    
    <ul>
        <li>الاسم، رقم الهوية، ومعلومات الاتصال (مثل رقم الجوال والبريد الإلكتروني).</li>
        <li>الجنس، العمود، الجنسية.</li>
        <li>تفاصيل التاريخ الطبي، بما في ذلك الأمراض الصاحبة، والأدوية.</li>
    </ul>

     <p><strong style="font-weight: 700;">طريقة جمع البيانات:</strong> سُجمع بياناتك الشخصية من خلال الوسائل التالية: البرز، الكمبيوتر، المقبلة الشخصية التي قجرى من قبل موظفي الجهة المسؤولة (غير الإنترنت أو حضورة)، الاتصالات عبر التعليمين، الرسائل النفسية، الفريد الإلكتروني، والعلامات.</p>

  <p><strong style="font-weight: 700;">الأساس القانوني:</strong> ستتم معالجة بياناتك الشخصية بناءً على واحد أو أكثر من الأسباب التالية (1) مولفتك، (بالتحديق مصلحة مشروعة للجهة المسؤولة عن المعالجة والمشاركين في هذا البرنامج لتحديدها (III)) لاستثناء التوازن والطلبات المتساقية والتفويق.</p>

  <p><strong style="font-weight: 700;">مدة المعالجة:</strong> يمكن أن يحدث إلى إعدادها المستخدمة في البرنامج، وتلك وفقاً للمتطلبات المحلية السليمانية، والإنترنت القانونية، والمساحل القضائية، والتوازن خارج الحدود الإقليمية، اعتباراً من تاريخ رسول هذا السوق. والإدالة أياسب، فإن أي بيانات شخصية جسمها ومعالجتها سلبياً من قبل الجهة المسؤولة أو العشائرين أن تتأثر خارج نطاق هذه الاتفاقية.</p>

  <h3>ج. العمل بالمدارسة</h3>
  <p>يجوز مشاركة بياناتك الشخصية مع الأطراف أهمية كحزء من عملية إدارة البرنامج وهذه الأطراف هي:</p>
  
  <ul>
    <li>(1) أهم الخدمة</li>
    <li>(2) المخاطر</li>
    <li>(3) طبيعية</li>
    <li>(4) أهم البيئة الدولي والمعدلة لدى مجموعة سنواتي</li>
    <li>(5) البيئات الصحية</li>
  </ul>

  <p>وبضع كل طرف من الأطراف أهمية كافة التوازن والأهمية بمواجهة المواد المعدلية أو الوثائق التي تخص صوصها البيئات كما يتناول ما يوسعه لجمع بياناتك الشخصية ومعالجتها والعائلة عليها.</p>

  <h3>د. حقوق حماية البيانات الشخصية</h3>
  <p>كمشارك في برنامج دعم ماي راي، سيقوم مقدم الخدمة بالرد على جميع استفساراتك المتعلقة بالبرنامج وأي طلبات بخصوص المعلومات التي تقدمها. وفقاً لقوانين حماية البيانات المعمول بها، يحق لك ممارسة حقوق حماية البيانات الخاصة بك، والتي تشمل:</p>
  
  <ul>
    <li>الحق في الوصول إلى بياناتك الشخصية</li>
    <li>تصحيح أي معلومات غير صحيحة</li>
    <li>طلب تقييد المعالجة</li>
    <li>الحصول على معلومات حول أغراض وطرق المعالجة</li>
    <li>طلب تدمير بياناتك الشخصية</li>
    <li>الحصول على بياناتك الشخصية بتنسيق واضح ومقروء</li>
  </ul>

  <p>لممارسة حقوق حماية البيانات الخاصة بك، يمكنك التواصل مع شركة بياني للرعاية الصحية المنزلية عبر:</p>
  
  <p style="text-align: center;">(i)أوالبريد الإلكتروني: pspsafety@baytihhc.com،</p>
  <p style="text-align: center;">(ii) 800 - BAYTI (22984)</p>
  

  <h3>هـ. إزالة الهوية والاستخدام الثانوي</h3>
  <p>كما ذكر أعلاه، فإن الوصول إلى بياناتك الشخصية كجزء من البرنامج سيكون محدوداً للغاية. خارج نطاق البرنامج، قد تحتاج مجموعة سانوفي والسلطات الصحية إلى إعادة استخدام البيانات التي يوفرها البرنامج لفهم ملف السلامة الخاص بالدواء بشكل أفضل، وذلك لتحسين الإدارة العامة للمرض. وهذا ما يسمى بالاستخدام الثانوي.</p>

  <p>لن تتمكن مجموعة سانوفي من الوصول إلى بياناتك الشخصية، إلا لأسباب تتعلق بسلامة الدواء، وفقاً للشروط المحددة أعلاه. سيتم إزالة الهوية عن بياناتك وتجميعها. وهذا يعني أنه سيتم إزالة جميع المعلومات التي يمكن أن تؤدي إلى تحديد هويتك الشخصية من قاعدة بيانات البرنامج. المعلومات التي ستبقى في قاعدة بيانات البرنامج المجهولة والمجمعة لن توفر أي تفاصيل عنك ولن تسمح بمعرفتك أو الاتصال بك. سيتم استخدام هذه البيانات لأغراض البحث والتحليل الثانوي فقط.</p>
  <p>.في أي مرحلة من مراحل البحث ولن يتم مشاركة سوى هذه أي البيانات التي لا تفصح (البيانات عن هويتك وليس البيانات التي )تحدد هويتك (1) مع المعلمين (2) مقدم الخدمة؛ التابعين له؛(3)
    وعة لدى الدوائي والسلامة التيقظ قسم(4) طبيبك؛ ة شركات (6) الصحية؛ الهيئات (5) سانوفي؛ مجم الإفصاح هذا يتم أن على سانوفي مجموع وفقاً .أعلاه المذكورة للشروط</p>
  
    <div class="consent-section">
  <h2 style="color: #0065a0; text-align: center; text-decoration-line: underline; font-weight: bolder;">الموافقة</h2>
  
  <p><em>* يجب تعبئتها فقط من قبل المريض نفسه/نفسها أو الوصي القانوني ولا يجوز لمقدم الرعاية الصحية (المعلم) أو أي شخص آخر تعبئة هذه الخانات في أي حال من الأحوال.*</em></p>

  <p>أنا ______ ، أب/أم و/أو الوصي القانوني لـ_________، ("القاصر") المقيم حالياً في ______، رقم هاتفي: ______.</p>

  <p>أوافق على تقديم بياناتي الشخصية وبيانات القاصر ذات الصلة إلى مقدم الخدمة/المعلم لتمكين مشاركة القاصر في البرنامج.</p>

  <p>وفي الحدود المذكورة أعلاه، أوافق كذلك على:</p>

  <ul>
    <li>جمع ومعالجة والاحتفاظ ببياناتي الشخصية وبيانات القاصر من قبل طبيب القاصر، مقدم الخدمة/المعلم وسانوفي للسلامة الدوائية والسلطات الصحية، وأفهم أن توقيعي على هذا النموذج لن يخفف من مسؤوليات طبيب القاصر أو مقدم الخدمة بأي حال من الأحوال.</li>
    <li>بالتوقيع على هذه الموافقة، أوافق بصفتي الشخصية كوصي قانوني للقاصر على مشاركته في البرنامج. لدي الأهلية القانونية لإعطاء موافقتي المستنيرة نيابة عن القاصر، بمعنى آخر، أنا أكبر من 21 عاماً وأنا الأب/الأم و/أو الوصي القانوني للقاصر.</li>
    <li>أوافق أيضاً على السماح لسانوفي باستخدام بياناتي المجهولة الهوية لأغراض البحث والتحليلات والنشر العلمي، للمساعدة في زيادة الوعي بالمرض وفهمه وإدارته بشكل أفضل.</li>
  </ul>

  <h3>الاعترافات:</h3>
  <ul>
    <li>أفهم أن أي أحداث متعلقة بالسلامة أو شكاوى المنتجات سيتم الإبلاغ عنها للأطراف المعنية وفقاً لمتطلبات الخصوصية والالتزامات القانونية.</li>
    <li>لقد تأكدت لي أن المشاركة في هذا البرنامج اختيارية ومجانية ويمكنني الانسحاب من البرنامج في أي وقت دون أن يؤثر ذلك على رعايتي الطبية أو إدارة مرضي.</li>
    <li>أقر بعدم تقديم أي تعويض مالي أو اعتبارات أخرى مقابل مشاركتي في هذا البرنامج.</li>
    <li>أفهم أنه سيتم نقل بياناتي الشخصية بين شركة بياني للرعاية الصحية المنزلية، وإدارة السلامة الدوائية والسلطات الصحية.</li>
    <li>أفهم أنني لن أتلقى إشعاراً عند كل نقل لبياناتي الشخصية بين أطراف البرنامج.</li>
  </ul>

  <p>لقد قرأت نموذج الموافقة المستنيرة وفهمت محتواه، وأتيحت لي الفرصة لطرح الأسئلة وتمت الإجابة عليها، وأعطيت الوقت الكافي لمناقشة المعلومات مع الآخرين والقاصر واتخاذ قرار بشأن مشاركة القاصر في البرنامج.</p>

  <p>أفهم أنه يمكنني ممارسة حقوقي في حماية البيانات، بما في ذلك سحب هذه الموافقة، في أي وقت، شفوياً أو كتابياً، دون تقديم أسباب ودون أن يترتب على ذلك أي عواقب سلبية عليّ أو على رعايتي الطبية.</p>

  <p>أؤكد أنني تلقيت وفهمت جميع المعلومات المتعلقة بالبرنامج. أفهم أنه يمكنني طرح الأسئلة في أي وقت. أؤكد أن جميع أسئلتي قد تمت الإجابة عليها وأنني حصلت على الوقت الكافي للتفكير.</p>

</div>
  </div>
  </div>
  <div className="form-header" style= "margin-bottom: 2rem; font-family: Arial, sans-serif;">
      <table className="form-metadata" style= "width: 100%; border-collapse: collapse; margin-bottom: 1rem;direction: ltr;display: inline-table; text-align: justify;">
        <tbody style= "border: 1px solid;">
          <tr style= "border: 1px solid;">
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Form Title</strong></td>
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">MAT code</strong></td>  
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Approval Date</strong></td>
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Edition</strong></td>
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Last Revision Date</strong></td>
            <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Next Revision Date</strong></td>
          </tr>
          <tr>
            <td style= "border: 1px solid; padding-left: 10px;">Patient Consent Form- Dupixent (Adult- Arabic)</td>
            <td style= "border: 1px solid; padding-left: 10px;">MAT-AE-2500625/v1/July 2025</td>
            <td style= "border: 1px solid; padding-left: 10px;">July 2025</td>
            <td style= "border: 1px solid; padding-left: 10px;">2</td>
            <td style= "border: 1px solid; padding-left: 10px;">July 2025</td>
            <td style= "border: 1px solid; padding-left: 10px;">July 2027</td>
          </tr>
        </tbody>
      </table>
    </div>
`;


  const handleSubmitClick = () => {
    if (isChecked) {
      setShowModal(true);
    }
  };


  return (
    <>
      <ArabicConsentModal
        show={showModal}
        onClose={() => setShowModal(false)}
        programObjectiveHTML={programObjectiveHTML}
        formType='Adult'
        Language="Arabic"
      />
      <div
        className="consent-container"
        dir="rtl"
        style={{
          textAlign: 'right',
          fontFamily: "'Arial Arabic', 'sans-serif'",
          marginRight: "3%",
          marginTop: "0px"
        }}
      >
        <h1>نموذج إقرار موافقة المريض البالغ عقار دوبكسنت</h1>
        <div dangerouslySetInnerHTML={{ __html: programObjectiveHTML }} />
        <div className="form-controls"
         dir="rtl"
            style={{
              textAlign: 'right',
              fontFamily: "'Arial Arabic', 'sans-serif'"
            }}>
          <div className="" >
            <label>
              <input
                type="checkbox"
                required
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              نا أوافق
            </label>
          </div>
          <button
            style={{
              background: "rgb(25, 118, 210)",
              border: "none",
              color: "rgb(255, 255, 255)",
              padding: "10px",
              textAlign: "center",
              textDecoration: "none",
              display: "inline-block",
              fontSize: "14px",
              cursor: isChecked ? "pointer" : "not-allowed",
              opacity: isChecked ? 1 : 0.3,
              borderRadius: '4px',
            }}
            onClick={isChecked ? handleSubmitClick : null}
            disabled={!isChecked}
          >
            تقديم
          </button>
        </div>
      </div>
    </>
  );
};

export default ConsentAdultArabicUAE;
